export const normalizeMetrics = (metricsArray) => {
  if (Array.isArray(metricsArray)) {
    return metricsArray;
  }
  
  if (metricsArray && typeof metricsArray === "object") {
    return Object.entries(metricsArray).map(([key, value]) => {
      if (value && typeof value === "object" && "current" in value) {
        return [key, value];
      }
      return [
        key,
        {
          current: typeof value === "number" ? value : 0,
          growthPercentage: 0,
          trend: "up",
        },
      ];
    });
  }
  
  return [];
};

export const convertDate = (iso) => {
  if (!iso || !iso.includes("T")) return "N/A";

  const cleaned = iso.replace("Z", "").split(".")[0];
  const [date] = cleaned.split("T");

  if (!date) return "";
  const [year, month, day] = date.split("-");

  return day && month && year ? `${day}/${month}/${year}` : "";
};

export  const formatTime = (isoString) => {
    if (!isoString) return "N/A";

  const cleaned = isoString.replace("Z", "").split(".")[0];
  const [, time] = cleaned.split("T");
  if (!time) return "N/A";

  const [hour, minute] = time.split(":");
  return `${hour}:${minute}`;
  };

  
export  const renderDateTime = (dateTime) => {
  if (!dateTime) return "N/A";
  return `${convertDate(dateTime)}, ${formatTime(dateTime)}`;
};

export const trimToWordLimit = (text = "", wordLimit = 25) => {
    const words = text.trim().split(/\s+/);
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(" ") + "...";
};

export const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
};